import { Controller } from '@hotwired/stimulus'
import ApexCharts from 'apexcharts'

export default class extends Controller {
  static values = { data: Array, name: String, categories: Array }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  initializeChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    const options = {
      colors: ['#eab308', '#008FFB', '#00E396', '#10b981', '#FEB019'],
      chart: {
        type: 'bar',
        toolbar: { show: false },
        height: '100%',
        parentHeightOffset: 0,
        stacked: true,
      },
      title: {
        text: this.nameValue,
        align: 'center',
        style: {
          fontSize: '20px',
          fontWeight: 'bold',
        },
      },
      series: this.dataValue,
      xaxis: {
        categories: this.categoriesValue,
        labels: {
          style: {
            fontSize: '12px',
            fontWeight: '500',
            colors: '#374151',
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            fontSize: '12px',
            fontWeight: '500',
          },
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '11px',
          fontWeight: 'normal',
          colors: ['#ffffff'],
        },
      },
      tooltip: {
        enabled: true,
        intersect: false,
        shared: true,
        y: {
          formatter: function (value, { seriesIndex, dataPointIndex, w }) {
            const seriesName = w.config.series[seriesIndex].name
            return `${seriesName}: ${value}`
          },
        },
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const categoryName = w.config.xaxis.categories[dataPointIndex] || 'Categoria'
          let html = `<div class="bg-white border border-gray-200 rounded-lg shadow-lg p-3">`
          html += `<div class="font-semibold text-gray-800 mb-2">${categoryName}</div>`

          // Calculate total
          let total = 0
          series.forEach((serieData) => {
            total += serieData[dataPointIndex] || 0
          })

          // Show each series value
          w.config.series.forEach((serie, index) => {
            const value = series[index][dataPointIndex] || 0
            const color = w.config.colors[index]
            html += `<div class="flex items-center justify-between mb-1">`
            html += `<div class="flex items-center">`
            html += `<div class="w-3 h-3 rounded mr-2" style="background-color: ${color}"></div>`
            html += `<span class="text-sm text-gray-600">${serie.name}:</span>`
            html += `</div>`
            html += `<span class="text-sm font-medium text-gray-800">${value}</span>`
            html += `</div>`
          })

          // Show total
          html += `<div class="border-t border-gray-200 pt-2 mt-2">`
          html += `<div class="flex items-center justify-between">`
          html += `<span class="text-sm font-semibold text-gray-700">Total:</span>`
          html += `<span class="text-sm font-bold text-gray-900">${total}</span>`
          html += `</div>`
          html += `</div>`

          html += `</div>`
          return html
        },
      },
      plotOptions: {
        bar: {
          distributed: false,
          columnWidth: '60%',
          borderRadius: 4,
          borderRadiusApplication: 'end',
          borderRadiusWhenStacked: 'last',
        },
      },
      states: {
        hover: {
          filter: {
            type: 'none',
          },
        },
      },
      legend: {
        show: true,
        position: 'top',
        fontSize: '14px',
      },
      responsive: [
        {
          breakpoint: 9999,
          options: {
            chart: {
              height: '100%',
            },
          },
        },
      ],
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }
}
